import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { Empreendimento } from "../../../../../incorporacao/domain/models/empreendimento";
import { EmpreendimentoDropDown } from "../../../../domain/models/empreendimento";
import { IncorporacaoBlocoDropDown } from "../../../../domain/models/incorporacao_bloco_dropdown";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";

type Props = {
  empreendimentos: EmpreendimentoDropDown[];
  centrosCusto: CentroCustoDropDown[];
  blocos: IncorporacaoBlocoDropDown[];
  empreendimento: Empreendimento | undefined;
  selectedEmpreendimento: EmpreendimentoDropDown | null;
  selectedCentroCusto: CentroCustoDropDown | null;
  selectedBlocos: IncorporacaoBlocoDropDown[] | undefined;
  onBlocosChange: (blocos: IncorporacaoBlocoDropDown[] | null) => void;
};

export const Header = ({
  empreendimentos,
  centrosCusto,
  blocos,
  empreendimento,
  selectedEmpreendimento,
  selectedCentroCusto,
  selectedBlocos,
  onBlocosChange,
}: Props) => {
  return (
    <>
      <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode">
        <FormContainer title="Obra" arrangement="fullRow" border={false}>
          <>
            <DefaultAutocomplete
              readOnly
              label="Empreendimento"
              options={empreendimentos}
              getOptionLabel={x => x.descricao}
              getOptionKey={x => x.idEmpreendimento}
              value={selectedEmpreendimento}
              onChange={() => { }}
            />
            <DefaultAutocomplete
              readOnly
              label="Centro de Custo"
              options={centrosCusto}
              getOptionLabel={x => x.title}
              getOptionKey={x => x.id}
              value={selectedCentroCusto}
              onChange={() => { }}
            />
            <DefaultSelectInput
              name="tipo"
              label="Tipo"
              readOnly
              value={empreendimento?.tipo}
              options={[
                { id: 1, label: 'Apartamento' },
                { id: 2, label: 'Casa' },
                { id: 3, label: 'Outro' },
              ]}
            />
            <DefaultInput
              name="descricao"
              label="Descrição"
              readOnly
              value={empreendimento?.descricao}
            />
          </>
        </FormContainer>
      </div>

      <CascateList title="Filtros" defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
            <DefaultMultiAutocomplete
              label="Blocos"
              options={blocos}
              getOptionLabel={x => x.descricao}
              getOptionKey={x => x.idIncorporacaoBloco}
              value={selectedBlocos}
              onChange={onBlocosChange}
            />
          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={() => onBlocosChange(null)}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
};
